import Vue from 'vue';
import { VNode } from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from "Store"
import UserMixin from 'Mixins/UserMixin';
import ApiFactory from 'Api/ApiFactory';

import CustomComponentWrapperComponent from "Components/Utils/ComponentWrapper";

////import "allowed" components
import CustomModalTextComponent from "Components/Utils/Modals/ModalTextComponent";
import AlertComponent from "Components/Utils/Alerts/AlertComponent"; 
import AlertWarningComponent from "Components/Utils/Alerts/AlertWarningComponent"; 
import AlertSuccessComponent from "Components/Utils/Alerts/AlertSuccessComponent"; 
import {VueFacebookPixel}  from 'Components/Utils/Analytics/VueFacebookPixel';

export interface IVueProviderConfig {
    reCaptchaToken: string,
    dwApiUrl: string,
    webApiUrl: string,
    locale: string,
    currencyCode: string,
    currencyLeft: boolean,
    currencySpacing: boolean,
    currencySymbol: string,
    currencyDecimalDigits: number,
    currencyDecimalSeparator: string,
    currencyGroupSeparator: string,
    dateFormatShort: string,
}

export class VueProvider {
    
    private static config: IVueProviderConfig;
    
    static init(config: IVueProviderConfig): void {
        
        this.config = config;
        
        ApiFactory.setApiUrl(config.webApiUrl || '');
        ApiFactory.setDwApi(config.dwApiUrl || '');
        ApiFactory.setReCaptchaToken(config.reCaptchaToken || '');
        
        this.setupAutoCloseDirective();
        this.setupVisibleDirective();
        
        Vue.use(VueAxios, axios);
        Vue.use(VueFacebookPixel);
        
        new Vue({
            el: '#app',
            mixins: [UserMixin],
            components: {
                CustomComponentWrapperComponent,
                CustomModalTextComponent, //TODO - use component where it is used - to AVOID this initialization
                AlertComponent,
                AlertWarningComponent,
                AlertSuccessComponent,
            },
            store: store.original, // Inject the classic Vuex store
            data: {},
            methods: {},
        });
    }
    
    
    static getInstance(): Vue.VueConstructor {
        let norriqVue = Vue.extend({
        });
        return norriqVue;
    }
    
    
    private static setupVisibleDirective(): void{
        
        const bindElement = (elm: any, binding: any, vNode: VNode) => {
            const show = !!binding.value; 
            elm.style.visibility = show ? 'visible' : 'hidden';
            elm.style.opacity = show ? '1' : '0';
            
        }
        
        const unbindElement = (elm: any) => {
            elm.style.visibility = 'visible';
            elm.style.opacity = '1';
        }
        
        Vue.directive('visible', {
            bind: (elm: any, binding: any, vNode: VNode) =>{bindElement(elm, binding, vNode)},
            unbind: (elm: any) => unbindElement(elm),
            // componentUpdated: (elm: any, binding: any, vNode: VNode) =>{bindElement(elm, binding, vNode)},
            update: (elm: any, binding: any, vNode: VNode) =>{bindElement(elm, binding, vNode)},
        });
    }
    
    private static setupAutoCloseDirective(): void {
        
        const handlerKey = '_vue_autoclose_handler_';
        
        const bindElement = (elm: any, binding: any, vNode: VNode) => {
            
            //Ensure that setup is done before continuing.
            var initialMacroTaskEnded = false;
            setTimeout(() => {
                initialMacroTaskEnded = true;
            }, 0);
            
            //Build event handler.
            elm[handlerKey] = (ev: any) => {
                
                /*
                * Find the trigger element eg. a button so clicks on the trigger are ignored thus avoiding double event invocation.
                */
                const elementTrigger = document.querySelector(`[aria-controls="${elm.id}"]`);
                
                if (elm.id.length < 1) {
                    return null;
                }
                
                /* @Note
                * Path is better than just contains as it tests if the element was there when clicked rather than now.
                * Path check = check when clicked
                * Contains check = check now.
                */
                const path = (typeof ev.composedPath == 'function' ? ev.composedPath() : undefined);
                const elementWasNotClicked = path ? path.indexOf(elm) < 0 : !elm.contains(ev.target);
                
                const elementTriggerWasNotClicked = path ? path.indexOf(elm) < 0 : (elementTrigger && !elementTrigger.contains(ev.target));
                if (initialMacroTaskEnded && elementWasNotClicked && elementTriggerWasNotClicked) {
                    if (binding.value != null) {
                        return binding.value.call(vNode.context, ev, elm);
                    } else {
                        const elmElement = elm as HTMLElement;
                        if (elmElement.className.indexOf('show') > 0) {
                            vNode.context.$root.$emit('bv::toggle::collapse', elm.id);
                        }
                    }
                }
                return null;
            };
            document.documentElement.addEventListener('click', elm[handlerKey], false);
            
        };
        
        const unbindElement = (elm: any) => {
            document.documentElement.removeEventListener('click', elm[handlerKey], false);
            delete elm[handlerKey];
        }
        
        Vue.directive('autoClose', {
            bind: (elm: any, binding: any, vNode: VNode) => bindElement(elm, binding, vNode),
            unbind: (elm: any) => unbindElement(elm)
            
        });
    }
}

//TODO: https://pusher.com/tutorials/authentication-vue-vuex
